import { NavLink } from "react-router-dom";
import { FaInstagram, FaMapMarkerAlt, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import "./style.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner container py-5">
        <div className="row g-4">
          <div className="col-md-4">
            <h3 className="site-footer__brand">Hotel Marechal Express</h3>
            <p className="site-footer__lead">
              Conforto, hospitalidade e uma estadia memorável em Laranjeiras do Sul.
            </p>
          </div>
          <div className="col-md-4">
            <h4 className="site-footer__title">Navegação</h4>
            <nav className="site-footer__nav d-flex flex-column gap-2">
              <NavLink to="/">Início</NavLink>
              <NavLink to="/acomodações">Acomodações</NavLink>
              <NavLink to="/estrutura">Estrutura</NavLink>
              <NavLink to="/localizacao">Localização</NavLink>
              <NavLink to="/termos">Termos e condições</NavLink>
            </nav>
          </div>
          <div className="col-md-4">
            <h4 className="site-footer__title">Contato</h4>
            <ul className="site-footer__contacts list-unstyled mb-0">
              <li>
                <FaMapMarkerAlt className="site-footer__icon" aria-hidden />
                R. Mal. Cândido Rondon, 2290 — Água Verde, Laranjeiras do Sul/PR
              </li>
              <li>
                <FaPhoneAlt className="site-footer__icon" aria-hidden />
                <a href="tel:+554236352720">(42) 3635-2720</a>
              </li>
              <li>
                <FaWhatsapp className="site-footer__icon" aria-hidden />
                <a href="https://wa.me/5542933008907" target="_blank" rel="noopener noreferrer">
                  (42) 9 3300-8907
                </a>
              </li>
            </ul>
            <a
              href="https://www.instagram.com/hotelmarechalexpress"
              target="_blank"
              rel="noopener noreferrer"
              className="site-footer__social mt-3 d-inline-flex align-items-center gap-2"
            >
              <FaInstagram aria-hidden />
              Instagram
            </a>
          </div>
        </div>
      </div>
      <div className="site-footer__bar text-center py-3">
        <small>
          © {year} Hotel Marechal Express — Todos os direitos reservados
        </small>
      </div>
    </footer>
  );
}

export default Footer;
